import { DocumentTypeDocument } from '../DocumentTypes/queryBuilder';
import { EquipmentDocument } from '../Equipment/queryBuilder';
import { create } from '../replication-v2/FamilyMember/create';
import { FamilyMember } from '../replication-v2/FamilyMember/FamilyMember';
import { ConfigBuilder, doNotAutoSync, pull, replicate } from '../replication-v2/replicate';
import { RxdbCollectionNameV2 } from '../replication-v2/RxdbCollectionNameV2';
import { SiteDocument } from '../Site/queryBuilder';
import {
  BorerDocumentUploadDocument,
  borerDocumentUploadPullModifier,
  borerDocumentUploadPullQueryBuilder,
} from './queryBuilder';

export function borerDocumentUploadFamilyMember(
  configBuilder: ConfigBuilder,
  documentTypes: FamilyMember<DocumentTypeDocument>,
  equipment: FamilyMember<EquipmentDocument>,
  sites: FamilyMember<SiteDocument>,
): FamilyMember<BorerDocumentUploadDocument> {
  // Note: BORER_DOCUMENT_UPLOAD pulls from `borerDocumentFeed` and thus refers to the `borer_document` table.
  const syncConfig = configBuilder<BorerDocumentUploadDocument>(
    RxdbCollectionNameV2.BORER_DOCUMENT_UPLOAD,
  );
  doNotAutoSync(syncConfig);

  const pullConfig = pull(syncConfig, borerDocumentUploadPullQueryBuilder);
  // BUG: `borerDocumentUploadPullModifier` should take as `BorerDocumentUploadDocument`, not a `BorerDocumentUpload`.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  pullConfig.modifier = borerDocumentUploadPullModifier as unknown as any;

  const replicationState = replicate(syncConfig);
  return create(RxdbCollectionNameV2.BORER_DOCUMENT_UPLOAD, replicationState, [
    documentTypes,
    equipment,
    sites,
  ]);
}
